import { apiGet, apiPost } from "./client.js";
import type { SubscriptionWithPlan, BillingSummary } from "./types.js";

export interface CheckoutResponse {
  checkoutUrl: string;
}

export interface PortalResponse {
  portalUrl: string;
}

export interface SubscriptionResponse {
  subscription: SubscriptionWithPlan | null;
}

export interface BillingSummaryResponse {
  summary: BillingSummary;
}

export function createCheckoutSession(
  orgId: string,
  planId: string,
  websiteId: string,
): Promise<CheckoutResponse> {
  return apiPost<CheckoutResponse>("/billing/checkout", {
    orgId,
    planId,
    websiteId,
  });
}

export function createPortalSession(orgId: string): Promise<PortalResponse> {
  return apiPost<PortalResponse>("/billing/portal", { orgId });
}

export function startTrial(
  orgId: string,
  planId: string,
  websiteId: string,
): Promise<{ ok: boolean }> {
  return apiPost<{ ok: boolean }>("/billing/trial", {
    orgId,
    planId,
    websiteId,
  });
}

export function getSubscription(orgId: string): Promise<SubscriptionResponse> {
  return apiGet<SubscriptionResponse>(
    `/billing/subscription?orgId=${encodeURIComponent(orgId)}`,
  );
}

export function getBillingSummary(
  orgId: string,
): Promise<BillingSummaryResponse> {
  return apiGet<BillingSummaryResponse>(
    `/billing/summary?orgId=${encodeURIComponent(orgId)}`,
  );
}

export interface UpcomingInvoice {
  amountDueEurCents: number;
  periodEnd: string;
  currency: string;
}

export function getUpcomingInvoice(
  orgId: string,
): Promise<{ invoice: UpcomingInvoice | null }> {
  return apiGet<{ invoice: UpcomingInvoice | null }>(
    `/billing/upcoming-invoice?orgId=${encodeURIComponent(orgId)}`,
  );
}
